module.exports = __webpack_public_path__ + "assets/img/case2.5739c942.png";